import React from 'react';
import { APP_VERSION } from '../version';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <p className='copyright'> App version: {APP_VERSION} © Grab</p>
        </footer>
    );
}

export default Footer;